import { configureHttpClient } from '@/shared/api/httpClient';
import { refreshSession } from './refreshSession';
import { clearSession, getSession } from './sessionStore';

/**
 * Spina klient HTTP z magazynem sesji.
 *
 * Wywolywane raz, przy starcie aplikacji (`main.tsx`), zanim wystartuje React —
 * dzieki temu nawet zadania wystrzelone podczas pierwszego renderu maja juz
 * komplet naglowkow uwierzytelnienia.
 *
 * Osobny modul, zeby `shared/api` nie zalezalo od `features/auth`
 * i nie powstal cykl importow.
 */
export function installAuthBridge(): void {
  configureHttpClient({
    getAccessToken: () => getSession()?.accessToken ?? null,
    getSessionId: () => getSession()?.sessionId ?? null,
    refreshAccessToken: refreshSession,
    onAuthenticationLost: clearSession,
  });
}
